import { Component, OnInit, OnDestroy } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { PortalProveedorService } from './services/portal-proveedor.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {


  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
  ) {
    this.initializeApp();
  }

  ngOnInit() {}

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.setModoVista();
    });
  }

  setModoVista() {
    const modoVista = localStorage.getItem('modoVista');
    if (!modoVista) {
      const platformsSupperted = this.platform.platforms();
      if (platformsSupperted.includes('desktop') || platformsSupperted.includes('tablet')) {
        localStorage.setItem('modoVista', 'escritorio');
      } else {
        localStorage.setItem('modoVista', 'cards');
      }
    }
  }

}
